var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mapbox"},[_c('div',{staticClass:"bg-image"},[_c('div',{ref:"chartsDOM",staticClass:"map-charts"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }